import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IFuelPrice} from "../../../models/IFuelPrice";
import {fetchFuelPrices, fetchSetFuelPrice} from "./actions";

interface IFuelPriceState {
    prices: IFuelPrice[];
    isLoading: boolean;
    isSaving: boolean;
    error: string | null;
}

const initialState: IFuelPriceState = {
    prices: [],
    isLoading: false,
    isSaving: false,
    error: null,
};

export const FuelPriceSlice = createSlice({
    name: "fuel_price",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ── Получение всех цен ──
            .addCase(fetchFuelPrices.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(
                fetchFuelPrices.fulfilled,
                (state, action: PayloadAction<IFuelPrice[]>) => {
                    state.prices = action.payload;
                    state.isLoading = false;
                },
            )
            .addCase(fetchFuelPrices.rejected, (state, action) => {
                state.isLoading = false;
                state.error = typeof action.payload === "string"
                    ? action.payload
                    : "Ошибка загрузки цен топлива";
            })

            // ── Сохранение одной цены (обновляем строку в списке) ──
            .addCase(fetchSetFuelPrice.pending, (state) => {
                state.isSaving = true;
                state.error = null;
            })
            .addCase(
                fetchSetFuelPrice.fulfilled,
                (state, action: PayloadAction<IFuelPrice>) => {
                    state.prices = state.prices.map((p) =>
                        p.fuel_type === action.payload.fuel_type ? action.payload : p,
                    );
                    state.isSaving = false;
                },
            )
            .addCase(fetchSetFuelPrice.rejected, (state, action) => {
                state.isSaving = false;
                state.error = typeof action.payload === "string"
                    ? action.payload
                    : "Ошибка сохранения цены топлива";
            });
    },
});

export default FuelPriceSlice.reducer;
